// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import axios from 'axios'

// ** 读取当前界面语言：从 localStorage 读取（登录页选择后写入），默认中文；仅支持 zh / id
const getCurrentLang = () => {
  try {
    const stored = window.localStorage.getItem('app-lang')
    return stored === 'id' ? 'id' : 'zh'
  } catch (e) {
    return 'zh'
  }
}

i18n

  // Enables the i18next backend
  .use(Backend)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    // 界面语言：登录页选择后存 localStorage，这里据此初始化；后续由 languageChanged 同步
    lng: getCurrentLang(),
    fallbackLng: 'zh',

    // 支持的语言：中文 / Bahasa Indonesia
    supportedLngs: ['zh', 'id'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    backend: {
      /* translation file path */
      loadPath: `${process.env.PUBLIC_URL}/assets/data/locales/{{lng}}.json`
    },
    debug: false,
    keySeparator: false,
    nsSeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

// ** 全局 axios 附加 X-Lang 请求头，后端据此返回对应语言的消息（zh/id）。
// ** 覆盖未走 jwtService 拦截器的 axios 直用请求，并随语言切换同步更新。
const syncAxiosLang = lng => {
  axios.defaults.headers.common['X-Lang'] = lng === 'id' ? 'id' : 'zh'
}
i18n.on('languageChanged', lng => {
  try {
    window.localStorage.setItem('app-lang', lng === 'id' ? 'id' : 'zh')
  } catch (e) { /* 忽略 */ }
  syncAxiosLang(lng)
})
syncAxiosLang(getCurrentLang())

export default i18n
